import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const EditPhoneModal = ({ show, handleClose, phone, onChange, onSave }) => {
    return (
        

        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Phone</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Phone Type</Form.Label>
                            <Form.Control 
                                name="name"
                                value={phone.name}
                                onChange={onChange}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Number</Form.Label>
                            <Form.Control 
                                name="number"
                                value={phone.number}
                                onChange={onChange}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Location</Form.Label>
                            <Form.Control 
                                name="location"
                                value={phone.location}
                                onChange={onChange}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>User</Form.Label>
                            <Form.Control 
                                name="user"
                                value={phone.user}
                                onChange={onChange}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Vendor</Form.Label>
                            <Form.Control 
                                name="vendor"
                                value={phone.vendor}
                                onChange={onChange}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>MAC Address</Form.Label>
                            <Form.Control 
                                name="mac"
                                value={phone.mac}
                                onChange={onChange}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        
                        </Col>
                    </Row>
                  
                    
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button id='modalSubmitButton' variant="success" onClick={onSave}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditPhoneModal;